// src/App.jsx
import React from 'react';
import AppRoutes from './routes';
import AddToHome from './components/AddToHome';
import { Toaster } from './components/ui/toaster';
import { useNavigationHandler } from './hooks/useNavigationHandler';
import { useMobileNavigation } from './hooks/useMobileNavigation';
import UpdateNotification from './components/UpdateNotification';
import { useLocation } from 'react-router-dom';

const App = () => {
  const location = useLocation();
  
  // Initialize navigation handlers
  useNavigationHandler();
  useMobileNavigation();

  return (
    <div className="App">
      <AppRoutes key={location.pathname} />
      <AddToHome />
      <Toaster />
      <UpdateNotification />
    </div>
  );
};

export default App;
